// eslint-disable-next-line import/no-cycle
import { selectIsAuthenticated } from 'shared/map-search/selectors/user';
import { IProduct } from 'shared/map-search/types/analytics';
import { EDealType, EEntityType } from 'shared/map-search/types/chatModal';
import { callAuthenticationPopup } from 'shared/map-search/utils/authentication';

import { openChatModal, setOpenChatModalAfterAuth } from './openModal';
import { TThunkAction } from '../../types/redux';

interface IParameters {
  defaultMessage?: string;
  shouldSendDefaultMessage?: boolean;
  offerId?: number;
  gaLabel?: string;
  dealType?: EDealType;
  offerType?: EEntityType;
  authorId?: number | null;
  product?: IProduct;
}

export function openChat({
  defaultMessage,
  shouldSendDefaultMessage,
  offerId,
  gaLabel,
  dealType,
  offerType,
  authorId,
  product,
}: IParameters): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const isUserAuthenticated = selectIsAuthenticated(state);

    if (isUserAuthenticated) {
      dispatch(
        openChatModal({
          defaultMessage,
          shouldSendDefaultMessage,
          offerId,
          gaLabel,
          dealType,
          offerType,
          authorId,
          product,
        }),
      );
    } else {
      dispatch(
        setOpenChatModalAfterAuth({
          defaultMessage,
          shouldSendDefaultMessage,
          offerId,
          gaLabel,
          dealType,
          offerType,
          authorId,
          product,
        }),
      );
      callAuthenticationPopup({ type: 'chats', autoRefresh: false });
    }
  };
}
